export default "__VITE_ASSET__KUr5udoK__"